import { Link } from 'react-router-dom';
import Connect from './Connect';
import LiveBlock from './LiveBlock';

export type NavProps = {
  /** Lower-case label rendered after METHA / in the brand. */
  ctxLabel?: string;
  /** Called when the user taps the hamburger (mobile). The Sidebar owns
   *  drawer state; the topbar just forwards the tap. */
  onOpenMobileMenu?: () => void;
};

/**
 * Slim top bar — global, persistent. Pairs with Sidebar.tsx (icon rail)
 * for navigation. Carries: hamburger (mobile only), brand + ctx label,
 * compact protocol-condition LEDs, live block, wallet connect.
 */
export default function Nav({ ctxLabel = 'dapp', onOpenMobileMenu }: NavProps) {
  return (
    <header className="nav">
      <div className="nav-inner">
        <button
          type="button"
          className="nav-hamburger"
          aria-label="Open menu"
          onClick={onOpenMobileMenu}
        >
          <span aria-hidden="true" />
          <span aria-hidden="true" />
          <span aria-hidden="true" />
        </button>

        <Link to="/" className="brand" aria-label="Metha Biofund — back to overview">
          <img
            className="brand-logo"
            src="/images/logo.png"
            srcSet="/images/logo.png 1x, /images/logo2x.png 2x"
            alt="Metha Biofund"
          />
          <span className="slash">/</span>
          <span className="ctx-label">{ctxLabel}</span>
        </Link>

        {/* Compact protocol-condition LEDs. Hover any dot for the full
         *  cond.{a,b,c} label + live/planned state. Replaces the wide
         *  .cond-row pill set that used to live in the topbar. */}
        <CondDots />

        <div className="nav-spacer" />

        <div className="nav-actions">
          <LiveBlock />
          <Connect />
        </div>
      </div>
    </header>
  );
}

function CondDots() {
  return (
    <div className="cond-dots" aria-label="Protocol conditions">
      <span className="cond-dot live"    title="cond. b — live"></span>
      <span className="cond-dot live"    title="cond. c — live"></span>
      <span className="cond-dot planned" title="cond. a — planned"></span>
    </div>
  );
}
